import { useCallback, useEffect, useState } from 'react';

import useWindowEvent from './useWindowEvent';

const getScrollHeight = (element = null) => element?.scrollHeight || window.scrollY || 0;

const useScrollHeightThreshold = (comparison = () => true) => {
    const [isPastThreshold, setIsPastThreshold] = useState(false);

    const onScroll = useCallback(
        (e = null) => {
            const newHeight = getScrollHeight(e?.target);
            const value = comparison(newHeight);
            if (value !== isPastThreshold) {
                setIsPastThreshold(value);
            }
        },
        [comparison, isPastThreshold, setIsPastThreshold],
    );

    useWindowEvent('scroll', onScroll);

    useEffect(() => {
        onScroll();
    }, [onScroll]);

    return isPastThreshold;
};

export default useScrollHeightThreshold;
